module.exports = __webpack_public_path__ + "img/sss.68fc7a35.jpg";